const es = {
  'warnings.facebookAdAccount.missingPaymentMethod': 'Agrega un método de pago a tu cuenta de anuncios de Facebook',
  'warnings.socialPiper.missingPaymentMethod': 'Agrega un método de pago a tu suscripción de Social Piper',
};

export default es;
